import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AdminAddCourtPage = React.lazy(() => import(/* webpackChunkName: "AdminAddCourt" */ './Page'));
export const AdminAddCourt = () => (React.createElement(Page, { title: "Administrator Add Court" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AdminAddCourtPage, null)))));
